module.exports = __webpack_public_path__ + "static/media/6.47773edd.jpeg";